import React from 'react'
import cx from 'classnames'

import { useFlowFields } from 'common/builder/hooks/useFlowFields'
import { getFormulaInputFields } from 'common/builder/selectors/builder/fieldsSelectors'
import { getFormulaErrors } from 'common/fields/models/CustomField/validation'
import MCTextEditor, { IMCTextEditorLegacyProps } from 'components/MCTextEditor'
import { IMCTextEditorRef } from 'components/MCTextEditor/MCTextEditor'
import ValidationErrors from 'components/ValidationErrors'
import { IMinimalChangeEventHandler } from 'constants/constants'

import cm from './FormulaInput.module.css'

export const stripEmptyFallbacks = (value = '') => value.replace(/\|fallback:""/gm, '')

export type FormulaInputProps = IMCTextEditorLegacyProps & {
  errorsClassName?: string
  fullWidth?: boolean
}

const FormulaInput: React.ForwardRefRenderFunction<IMCTextEditorRef, FormulaInputProps> = (
  {
    className,
    errorsClassName,
    fullWidth,
    minRows = 3,
    multiline = true,
    onChange,
    value,
    ...rest
  },
  ref,
) => {
  const fields = useFlowFields(getFormulaInputFields)
  const [showErrors, setShowErrors] = React.useState(false)
  const errors = getFormulaErrors(value)

  const handleChange: IMinimalChangeEventHandler = (event) => {
    onChange?.({
      target: { ...event.target, value: stripEmptyFallbacks(event.target.value || '') },
    })
  }

  return (
    <div className={cx(cm.numberWrapper, className, { [cm.fullWidth]: fullWidth })}>
      <ValidationErrors
        errors={errors}
        show={showErrors}
        onShow={() => setShowErrors(true)}
        onHide={() => setShowErrors(false)}
        className={cx(cm.triangle, errorsClassName)}
      />

      <MCTextEditor
        {...rest}
        multiline={multiline}
        ref={ref}
        withEmoji={false}
        className={'m-b'}
        minRows={minRows}
        isValid={!errors.length}
        value={stripEmptyFallbacks(`${value || ''}`)}
        withDefaultStyles
        noLineBreaks
        getFields={() => fields}
        onChange={handleChange}
        fallbackMode="number"
      />
    </div>
  )
}

export default React.forwardRef(FormulaInput)
